import React from "react";
import Icon from "../../../icons";
import LoaderComponent from "../../Loader";

const InlineEditField = ({
  fieldKey,
  label,
  isUpdating,
  isEditing,
  isSaveEnabled,
  validationError,
  inputValue,
  displayValue,
  maxLength,
  onChange,
  onSave,
  onCancel,
  onEdit,
  suffix = null,
  showAddWhenEmpty = false,
  dataTestId,
}) => {
  const inputId = `${fieldKey}-input`;

  if (isUpdating) {
    return <LoaderComponent />;
  }

  if (isEditing) {
    return (
      <ul className="inline-edit-field">
        <li className={validationError ? "errorMsg" : ""}>
          <div className="formGroup">
            <div className="colFlex">
              <label htmlFor={inputId} className="sr-only">
                {label}
              </label>
              <input
                type="text"
                id={inputId}
                value={inputValue || ""}
                maxLength={maxLength}
                onChange={(event) => onChange(event.target.value)}
              />
              {validationError && <span>{validationError}</span>}
            </div>
            {suffix}
          </div>
          <div className="inline-edit-field__actions rowFlex">
            <button
              type="button"
              className={`statusCheck icon btn-cc btn-cc__transparent check ${isSaveEnabled ? "activeIcon" : "disabled"}`}
              disabled={!isSaveEnabled}
              onClick={onSave}
              aria-label={`Save ${label}`}
            >
              <Icon name="check" className="icon" />
            </button>
            <button
              type="button"
              className="btn-cc btn-cc__transparent"
              onClick={onCancel}
              aria-label={`Cancel editing ${label}`}
            >
              <Icon name="close" className="icon close" />
            </button>
          </div>
        </li>
      </ul>
    );
  }

  if (!displayValue) {
    return showAddWhenEmpty ? (
      <button type="button" className="pointer btn-cc btn-cc__transparent" onClick={() => onEdit("")}>
        add
      </button>
    ) : null;
  }

  return (
    <>
      {displayValue}
      {suffix}
      <span className="ml">
        <button
          type="button"
          className="icon ml__1 editDetail btn-cc btn-cc__transparent"
          onClick={() => onEdit(displayValue)}
          data-test={dataTestId}
          aria-label={`Edit ${label}`}
        >
          <Icon name="editActive" className="icon" />
        </button>
      </span>
    </>
  );
};

export default InlineEditField;
